import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	data: [],
	error: false,
	loading: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case types.FETCH_PACKET_LOADING:
				draft.data = [];
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_PACKET_SUCCESS:
				draft.data = action.payload;
				draft.loading = false;
				return;

			case types.FETCH_PACKET_ERROR:
				draft.loading = false;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
